import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

export const AUTH_REDUCER_KEY = "auth";

const initialState = {
  authenticated: false,
  username: "",
};

const authSlice = createSlice({
  name: AUTH_REDUCER_KEY,
  initialState,
  reducers: {
    setAuth: (state, { payload }) => {
      state.authenticated = payload.authenticated;
      state.username = payload.username ?? "";
    },
    clearAuth: () => initialState,
  },
});

export const { setAuth, clearAuth } = authSlice.actions;
export default authSlice.reducer;

export const useUsername = () =>
  useSelector((state) => state[AUTH_REDUCER_KEY].username);
export const useIsAuthenticated = () =>
  useSelector((state) => state[AUTH_REDUCER_KEY].authenticated);
